<template>
  <div class="detail-page">
    <div class="page-top">
      <div class="status-bar" :style="{ height: statusBarHeight + 'px' }"></div>
      <!-- 头像 -->
      <div class="user-content" v-if="curEv == 1 && userInfo">
        <img class="avatar" :src="userInfo.head_img" alt="" />
        <div class="nickname">{{ userInfo.truename }}</div>
      </div>
      <div
        class="app-padding"
        v-if="tabBarHeight"
        :style="{ height: tabBarHeight + 'px' }"
      >
        <div class="title">{{ title }}</div>
        <div class="back iconfont icon-fanhui" @click="bindBack"></div>
        <div
          class="share iconfont icon-zhuanfa"
          v-if="curTitle <= 1"
          @click="bindShare"
        ></div>
      </div>
      <van-tabs
        v-model="curTitle"
        @click="changeTitle"
        class="top-nav"
        v-if="curEv == 0"
      >
        <van-tab
          :title="item.title"
          v-for="(item, index) in tabList"
          :key="index"
        >
        </van-tab>
      </van-tabs>
      <div v-else class="top-nav">
        <div class="nav-list">
          <div
            class="nav-item"
            :class="{ 'nav-item-active': curTitle == index }"
            v-for="(item, index) in tabList"
            :key="index"
            @click="changeH5Title(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="my-swiper swiper-no-swiping"
      :style="{ paddingBottom: curEv == 1 ? '17vw' : '0vw' }"
    >
      <div
        class="swiper-wrapper"
        :style="{ paddingTop: statusBarHeight + tabBarHeight + 'px' }"
      >
        <transition
          v-for="(item, index) in tabList"
          :key="index"
          name="slide-fade"
        >
          <!-- v-show="curTitle == index" -->
          <div
            class="swiper-slide"
            :class="{ 'swiper-slide-active': curTitle == index }"
          >
            <SwiperItemComponent
              v-if="item.loaded"
              :data="item"
              :index="index"
              @addRecord="bindAddRecord"
            />
          </div>
        </transition>
      </div>
    </div>
    <!-- 分享组件 -->
    <van-overlay :show="showShare" @click="showShare = false" z-index="11">
      <ShareComponent
        v-if="showShare"
        class="share-container"
        @close="bindCloseShare"
        @link="bindClickLink"
        @image="bindClickImage"
        :copyUrl="qrcodeUrl"
        :linkShareIcon="linkShareIcon"
      />
    </van-overlay>
    <div class="footer" v-if="curEv == 1">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png"
        alt=""
      />
      <div class="flex-center">
        <div class="text1">打开 betterWE App</div>
        <div class="text2">见证身体变化，和我们一起越吃越瘦</div>
      </div>
      <div class="btn" @click="downloadApp">打开APP</div>
    </div>
    <AppRuler
      v-model="showRuler"
      :title="'修改' + rulerOptions.title"
      :unit="rulerOptions.unit"
      :oneGridValue="rulerOptions.oneGridValue"
      :defaultNum="rulerOptions.defaultNum"
      :maxNum="rulerOptions.max"
      :minNum="rulerOptions.min"
      @confirm="bindConfirm"
      :buried="getUpperCase(rulerOptions.field)"
    />
  </div>
</template>
<script>
import 'swiper/swiper-bundle.min.css'
import { rulerOptionsData } from './data.js'
import SwiperItemComponent from './components/detail-components/swiper-item-component'
import AppRuler from '@/components/app/ruler/index.vue'
import ShareComponent from '@/components/app/share'
export default {
  components: {
    SwiperItemComponent,
    ShareComponent,
    AppRuler
  },
  provide() {
    return {
      addRecord: this.bindAddRecord
    }
  },
  data() {
    return {
      showRuler: false,
      showShare: false,
      rulerOptions: {
        field: 'bmi',
        title: '',
        unit: '',
        oneGridValue: 1,
        defaultNum: 50,
        min: 0,
        max: 100
      },
      rulerOptionsData: rulerOptionsData,
      qrcodeUrl: '',
      linkShareIcon: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接'
        }
      ],
      title: '数据记录',
      tabBarHeight: 0, //顶部导航高度
      statusBarHeight: 0,
      swiper: null,
      curTitle: 0,
      tabList: [],
      curEv: 0, // 0 表示app 1表示h5
      userInfo: null
    }
  },
  watch: {
    curTitle(index) {
      if (this.tabList[index]) {
        this.tabList[index].loaded = true
      }
    }
  },
  created() {
    this.curEv = this.$http._isApp() ? 0 : 1
    this.getTabBar()
  },
  mounted() {
    this.setQrcodeUrl()
    this.getUserInfo()
    this.getTabList()
  },
  methods: {
    getUpperCase(str) {
      return str?.toLocaleUpperCase() || str
    },
    bindAddRecord(options, page) {
      this.rulerOptions = options
      this.showRuler = true
      this.bindConfirm = (value) => {
        page.bindConfirm(value)
      }
    },
    bindConfirm() {},
    downloadApp() {
      location.href =
        'https://member3.gymcity.com.cn/#/app-download?token=' +
        localStorage.getItem('token')
    },
    getUserInfo() {
      this.$http
        .getApp('member/UserBodyData/getUserInfoPlanetaryArchives', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userInfo = res.data
          }
        })
        .catch(() => {})
    },
    setQrcodeUrl() {
      this.qrcodeUrl = location.href + '&token=' + localStorage.getItem('token')
    },
    bindShare() {
      if (this.curTitle > 1) {
        return
      }
      this.showShare = true
    },
    bindCloseShare() {
      this.showShare = false
    },
    bindClickImage(index) {},
    bindClickLink(index) {
      switch (index) {
        case 0:
          this.shareFriend(0)
          break
        case 1:
          this.shareWechatCicle(0)
          break
      }
    },
    async getTabBar() {
      let res = await this.$betterwe.getAppBarHeight().catch(() => {})
      if (res) {
        this.tabBarHeight = res.toolsBarHeight
        this.statusBarHeight = res.statusBarHeight
      }
    },
    bindBack() {
      this.$http.appBack()
    },
    getParams(tabList) {
      let curField = this.$route.query.curField
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].field == curField) {
          this.curTitle = i
          break
        }
      }
    },
    changeTitle(index) {
      //this.swiper.slideTo(index, 0, false); //切换到第一个slide，速度为1秒
    },
    changeH5Title(index) {
      this.curTitle = index
    },
    //获取标签列表
    getTabList() {
      this.$http
        .getApp('member/UserBodyData/getUserBodyOptions', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (this.curEv == 1) {
              this.tabList = this.initTab(res.data.slice(0, 2))
            } else {
              this.tabList = this.initTab(res.data)
            }
            this.$nextTick(() => {
              this.getParams(this.tabList)
              this.tabList[this.curTitle].loaded = true
            })
          }
        })
        .catch(() => {})
    },
    initTab(list) {
      list.map((item, index) => {
        item.loaded = false
        item.rulerOptions = this.rulerOptionsData[item.field]
      })
      return list
    },
    initSwiper() {
      let self = this
      this.$nextTick(() => {
        this.swiper = new Swiper('.my-swiper', {
          slidesPerView: 'auto', //每页显示数量，auto为自动填充，3为每页显示3块
          centeredSlides: true, //轮播图自动居中
          spaceBetween: '0%', //轮播图左右之间的间距，配合css样式中的width实现效果
          initialSlide: 0, //轮播图初始下标位置
          autoHeight: false,
          //方法事件
          on: {
            //回调函数，swiper从当前slide开始过渡到另一个slide时执行
            slideChange: function () {
              self.curTitle = this.activeIndex
            }
          }
        })
      })
    },
    //分享到微信好友
    shareFriend(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc:
              ((this.userInfo && this.userInfo.truename) || 'TA') +
              '和你分享了神秘的身体档案,快来看看!',
            title: '#betterWE星球档案#',
            thumbnail:
              (this.userInfo && this.userInfo.head_img) ||
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a6d240504efd7fb383d93f2e297dcb9.png' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc:
              ((this.userInfo && this.userInfo.truename) || 'TA') +
              '和你分享了神秘的身体档案,快来看看!',
            title: '#betterWE星球档案#',
            thumbnail:
              (this.userInfo && this.userInfo.head_img) ||
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a6d240504efd7fb383d93f2e297dcb9.png' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信朋友圈
    shareWechatCicle(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc:
              ((this.userInfo && this.userInfo.truename) || 'TA') +
              '和你分享了神秘的身体档案,快来看看!',
            title: '#betterWE星球档案#',
            thumbnail:
              (this.userInfo && this.userInfo.head_img) ||
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a6d240504efd7fb383d93f2e297dcb9.png' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc:
              ((this.userInfo && this.userInfo.truename) || 'TA') +
              '和你分享了神秘的身体档案,快来看看!',
            title: '#betterWE星球档案#',
            thumbnail:
              (this.userInfo && this.userInfo.head_img) ||
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a6d240504efd7fb383d93f2e297dcb9.png' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-page {
  background: #f9f9f9;
  position: relative;
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;

  .app-padding {
    width: 100%;
    background-color: #4a3d6b;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .title {
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }

    .back {
      padding: 10px;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translate(0%, -50%);
      font-size: 16px;
      font-weight: 600;
      color: #fff;
    }

    .share {
      padding: 10px;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translate(0%, -50%);
      font-size: 16px;
      font-weight: 600;
      color: #fff;
    }

    .disabled-share {
      color: #898989;
    }
  }

  .status-bar {
    width: 100%;
    background-color: #4a3d6b;
  }

  .page-top {
    background-color: #4a3d6b;
    padding-bottom: 10px;
    position: static;
    left: 0;
    top: 0;
    z-index: 8;
    width: 100%;
    overflow: hidden;

    ::v-deep .van-tabs__nav {
      background-color: transparent;
    }

    ::v-deep .van-tabs__wrap {
      height: 32px;
    }

    ::v-deep .van-tab {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 30px;
      height: 30px;
      background: rgb(92, 81, 122);
      border-radius: 15px;
      margin: 0px 4px;
    }

    ::v-deep .van-tabs__line {
      display: none;
    }

    ::v-deep .van-tab--active {
      background: #ffffff;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
    }
  }

  .top-nav {
    margin-top: 10px;
  }

  .nav-list {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .nav-item {
      height: 30px;
      line-height: 30px;
      white-space: nowrap;
      background: rgb(92, 81, 122);
      border-radius: 15px;
      padding: 0px 19px;
      margin-right: 8px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
    }

    .nav-item-active {
      background: #ffffff;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
    }
  }

  .my-swiper {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .swiper-slide {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      box-sizing: border-box;
    }

    .swiper-slide-active {
      z-index: 999;
    }
  }
}

.swiper-wrapper {
  box-sizing: border-box;
}

.user-content {
  position: fixed;
  left: 24px;
  top: 6px;
  z-index: 10;
  display: flex;
  align-items: center;

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
    margin-right: 10px;
  }

  .nickname {
    max-width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.8);
    line-height: 25px;
  }
}

.share-container {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}

.footer {
  padding: 12px 20px;
  box-sizing: border-box;
  z-index: 10;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 64px;
  background: #272727;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    width: 40px;
    height: 40px;
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.06);
    border-radius: 13px;
    margin-right: 8px;
  }

  .flex-center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    margin-right: 8px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 18px;
  }

  .btn {
    text-align: center;
    width: 80px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 32px;
  }
}
</style>
